import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

export interface ApplicationFilterType {
  searchValue?: string;
  batchReferenceNumber?: string;
  status?: string;
  products?: string[];
  pageNumber?: number;
  pageSize?: number;
  sortField?: string;
  sortDirection?: string;
}

export enum ApplicationFilterKeys {
  BatchReferenceNumber = 'batchReferenceNumber',
}

@Injectable({
  providedIn: 'root'
})
export class ApplicationFilterCacheService {
  private filterValues: ApplicationFilterType = {};
  private readonly cachedFilterValues: BehaviorSubject<ApplicationFilterType> = new BehaviorSubject<ApplicationFilterType>(null);

  saveFilterValue<K extends keyof ApplicationFilterType>(key: K, value: ApplicationFilterType[K]): void {
    const newValues = { ...this.filterValues, [key]: value };
    this.updateFilterValuesIfChanged(newValues);
  }

  saveMultipleFilterValues(values: Partial<ApplicationFilterType>): void {
    const newValues = {...this.filterValues, ...values};
    this.updateFilterValuesIfChanged(newValues);
  }

  getFilterValue(): Observable<ApplicationFilterType> {
    return this.cachedFilterValues.asObservable();
  }

  private updateFilterValuesIfChanged(newValues: ApplicationFilterType): void {
    const current = this.filterValues;
    const changed = !this.areFiltersEqual(current, newValues);

    if (changed) {
      this.filterValues = newValues;
      this.cachedFilterValues.next({ ...this.filterValues });
    }
  }

  private areFiltersEqual(a: ApplicationFilterType, b: ApplicationFilterType): boolean {
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) return false;

    for (const key of aKeys) {
      if (a[key] !== b[key]) return false;
    }
    return true;
  }
}
